import { Component, HostListener, ViewChild } from '@angular/core';

import { NavigationEnd, Router } from '@angular/router';

import { IonContent, ModalController, Platform } from '@ionic/angular';

import { ToasterService, UtilsService } from '@commons/services';

import { CancelAsync, Student } from '@app/models';

import { ModalIframeComponent, ModalMarketingComponent } from '@app/modals';
import * as moment from 'moment-timezone';

import {
  AppInitService,
  CameraService,
  GamificationService,
  NavigationService,
  NetworkStatusService,
  PageLoaderService,
  PostalCodeService,
  StatsService,
  StudentDocumentsService,
  StudentService,
} from '@app/services';

import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';

import { EasyDebugDecorator } from '@app/decorators/easy-debug.decorator';

@EasyDebugDecorator
@Component({
  selector: 'student-documents-page',
  templateUrl: 'student-documents.page.html',
  styleUrls: ['student-documents.page.scss'],
})
export class StudentDocumentsPage extends CancelAsync {
  @ViewChild(IonContent, { static: true }) content: IonContent;
  @ViewChild('modalNEPH') modalNEPH: any;
  @ViewChild('modalStartUpNEPH') modalStartUpNEPH: any;
  @ViewChild('modalCategPermis') modalCategPermis: any;
  @ViewChild('modalLicenseNumber') modalLicenseNumber: any;
  @ViewChild('modalCategPermisChanged') modalCategPermisChanged: any;
  @ViewChild('modalDeleteDocument') modalDeleteDocument: any;
  @ViewChild('modalJustifSavoirPlus') modalJustifSavoirPlus: any;
  @ViewChild('drivingTheoryCertificateFileInput')
  drivingTheoryCertificateFileInput: any;
  @ViewChild('drivingLicenseRectoFileInput') drivingLicenseRectoFileInput: any;
  @ViewChild('drivingLicenseVersoFileInput') drivingLicenseVersoFileInput: any;

  isDebug = false;
  showLogs = false;

  student: Student;
  userLifeCycle: any;
  studentPurchases: any;
  configUser: any;
  cleanedPostalCode = '';

  longLoading = false;
  pageStart = Date.now();
  checkPageLoadingTimeInterval: any;
  initPageDone = false;
  pageLoaded = false;
  initServiceDone = false;
  statsSent = false;

  iconPath = './uikit-assets/icons/orion-svg-sprite.svg#';
  iconThemePath = './uikit-assets/icons/orion-svg-sprite-theme.svg#';

  pageTitle = 'Profil';
  activeLink = 'profil';
  blocHeaderTitle = 'Mes documents';
  blocHeaderBackTitle = 'Retour';
  blocHeaderBackUrl = 'profil';
  isBackBtn = true;

  screenWidth: number = window.innerWidth;
  isDesktop: boolean = this.screenWidth > 767 ? true : false;
  isCordova = false;

  stepChangeSub: any;
  pageLoaderSteps = [
    'init0',
    'init1',
    'init2',
    'init3',
    'init4',
    'init5',
    'initPage',
  ];
  hasMadeInit = false;

  navigationSubscription: any;

  offToastConf = {
    text: 'Tu es hors ligne : certaines actions sont indisponibles',
    bgcolor: 'var(--color-danger)',
    duration: '5000',
  };

  canSubmit = true;

  documentsForIndex: any = [];
  fetchDocumentsForindexFailed = false;
  documents: any = [];
  fetchStudentsDocumentsByUserIdFailed = false;
  registrationCertificate = null;
  updateFormRegistrationCertificate = false;
  drivingTheoryCertificate = null;
  drivingLicense = null;
  drivingLicenseType = null;

  regexDate =
    '(^((0)[1-9]|[1-2][0-9]|(3)[0-1])(\/|-)((0)[1-9]|(1)[0-2])(\/|-)[0-9]{4}$)|(^[0-9]{4}(\/|-)((0)[1-9]|(1)[0-2])(\/|-)((0)[1-9]|[1-2][0-9]|(3)[0-1])$)';
  regexNEPHNumber = '^[0-9]{12}$';
  regexFirstName = /^[A-Za-zÀ-ü'\-\s]+$/;

  registrationCertificateForm: UntypedFormGroup;
  registrationCertificateOptin = false;
  showRegistrationCertificateFormErrors = false;
  isRegistrationCertificateFormUploading = false;
  genderList = [
    { name: 'Homme', value: 'm' },
    { name: 'Femme', value: 'f' },
  ];
  licenseList = [
    { name: 'Permis B', value: 'Permis B' },
    { name: 'Permis B1, BE', value: 'Permis B1, BE' },
    { name: 'Permis A', value: 'Permis A' },
    { name: 'Autres : Permis C, D, E...', value: 'Autres : Permis C, D, E...' },
  ];

  drivingTheoryCertificateForm: UntypedFormGroup;
  showDrivingTheoryCertificateFormErrors = false;
  isDrivingTheoryCertificateFormUploading = false;
  drivingTheoryCertificateFile = null;
  drivingTheoryCertificateFileDirty = false;
  drivingTheoryCertificateFileName = null;
  maxDate = '0000-00-00';
  drivingTheoryCertificateOptin = false;

  drivingLicenseForm: UntypedFormGroup;
  showDrivingLicenseFormErrors = false;
  isDrivingLicenseFormUploading = false;
  drivingLicenseRectoFile = null;
  drivingLicenseRectoFileDirty = false;
  drivingLicenseRectoFileName = null;
  drivingLicenseVersoFile = null;
  drivingLicenseVersoFileDirty = false;
  drivingLicenseVersoFileName = null;

  formsConstructed = false;

  displayModalNEPH = false;
  displayModalStartUpNEPH = false;
  displayModalCategPermis = false;
  displayModalLicenseNumber = false;
  displayModalCategPermisChanged = false;
  displayModalDeleteDocument = false;
  displayModalJustifSavoirPlus = false;
  displayModalLastObtainedBadge = false;

  fromNEPHInfosModal = false;

  lastObtainedBadgeInDateRange = null;

  documentImageTypeUploading = null;
  documentDeleteType = null;
  documentDeleteText = null;

  showModalUploadMobile = false;
  showModalUpload = false;
  showModalDeleting = false;
  showModalErrorServer = false;
  showModal1 = false;
  closeText = "J'ai compris";

  showModalErrorServerText = '';

  errorMsg = '';

  hoverModaleDisable = true;
  initDataReady = false;

  showAutocompletes = true;

  @HostListener('window:resize', ['$event']) onResize(event) {
    this.screenWidth = window.innerWidth;
    this.isDesktop = this.screenWidth > 767 ? true : false;
  }

  constructor(
    public pageLoaderService: PageLoaderService,
    private appInitService: AppInitService,
    private statsService: StatsService,
    public router: Router,
    private studentService: StudentService,
    private navigationService: NavigationService,
    private networkService: NetworkStatusService,
    public utils: UtilsService,
    public platform: Platform,
    public toasterService: ToasterService,
    public modalController: ModalController,
    public formBuilder: UntypedFormBuilder,
    public studentDocumentsService: StudentDocumentsService,
    public postalCodeService: PostalCodeService,
    public cameraService: CameraService,
    public gamificationService: GamificationService
  ) {
    super({ cancel: false, subscription: null });

    this.checkPageLoadingTimeInterval = setInterval(() => {
      const now = Date.now();
      // 3 sec
      if (now - this.pageStart >= 3000) {
        this.longLoading = true;
        clearInterval(this.checkPageLoadingTimeInterval);
      }
    }, 200);

    if (!this.appInitService.done) {
      this.navigationService.timestamp = Date.now();
      this.navigationService.lastLink = this.router.url.substr(1);
      this.hasMadeInit = true;
    } else {
      this.hasMadeInit = false;
    }

    this.isCordova = this.platform.is('cordova');

    this.networkService.networkStatusObs$.subscribe(isNetworkOnline => {
      if (isNetworkOnline) {
        this.canSubmit = true;
      } else {
        this.canSubmit = false;
        this.launchToaster(this.offToastConf);
      }
    });

    this.userLifeCycle = this.studentService.getUserLifeCycle(this.student); // if student not ready return guest

    this.navigationSubscription = this.router.events.subscribe((e: any) => {
      // If it is a NavigationEnd event re-initalise the component
      if (e instanceof NavigationEnd) {
        if (
          !!this.navigationService.lastLink &&
          this.navigationService.lastLink === this.router.url.substr(1)
        ) {
          this.hasMadeInit = true;
          this.initPageDone = false;
          if (this.appInitService.done) {
            this.blocHeaderTitle = 'Mes documents';
            this.blocHeaderBackTitle = 'Retour';
            this.pageLoaderSteps = ['initApp', 'initPage'];
          } else {
            this.pageLoaderSteps = [
              'init0',
              'init1',
              'init2',
              'init3',
              'init4',
              'init5',
              'initPage',
            ];
          }
        }
      }
    });

    if (this.appInitService.done) {
      this.pageLoaderSteps = ['initApp', 'initPage'];
      this.pageLoaderService.setSteps(
        this.pageLoaderSteps.indexOf('initApp') + 1,
        this.pageLoaderSteps.length
      );
      this.initDataReady = true;
    }
    this.stepChangeSub = this.appInitService.onStepChange().subscribe(state => {
      if (state?.init >= 3 && state?.stepDone && !this.initPageDone) {
        this.initDataReady = true;
        this.initPage();
      }
      if (state?.init && state?.stepDone) {
        this.pageLoaderService.setSteps(
          state.init + 1,
          this.pageLoaderSteps.length
        );
      }
      if (state?.initDone) {
        this.initServiceDone = true;
        this.constructForms();
        this.initPage();
      }
    });
  }

  ionViewWillLeave() {
    // this.cancel = true;
    if (!!this.subscription) {
      this.subscription.unsubscribe();
    }
    if (!!this.navigationSubscription) {
      this.navigationSubscription.unsubscribe();
    }
    if (!!this.stepChangeSub) {
      this.stepChangeSub.unsubscribe();
    }
  }

  evslog(...args: any[]) {
    if (this.showLogs) {
      if (window.console) {
        console.log.apply(console, arguments);
      }
    }
  }

  dateToFormatFr(input?: any) {
    // console.log('-------------------');
    // console.log('dateToFormatFr input', input, typeof input);
    let output = this.dateToMoment(); // today by default
    if (!!input) {
      output = this.dateToMoment(input);
      if (typeof input === 'string') {
        output = this.dateToMoment(input);
        // if (!input.includes('+')) {
        //   console.log('input string', input);
        // }
        if (input.includes('/')) {
          console.error('input string', input);
        }
        // console.log('output', output);
        // console.log('-------------------');
      } else if (typeof input === 'number') {
        // timestamp
        output = this.dateToMoment(input);
        // console.log('input timestamp', input);
        // console.log('output', output);
        // console.log('-------------------');
      } else if (typeof input === 'object') {
        if (
          !moment.isMoment(input) &&
          !!input.year &&
          !!input.month &&
          !!input.day
        ) {
          // custom object
          const year = input.year;
          const month =
            Number(input.month) < 10
              ? '0' + Number(input.month)
              : Number(input.month);
          const day = input.day < 10 ? '0' + input.day : input.day;
          const str = year + '-' + month + '-' + day + ' 00:00:00';
          output = this.dateToMoment(str);
          // console.log('input custom object', input, str);
          // console.log('output', output);
          // console.log('-------------------');
        } else {
          // date object
          output = this.dateToMoment(input);
          // console.log('input date', input, input.isValid());
          // console.log('output', output);
        }
      }
    }
    if (!output.isValid()) {
      console.log('-------------------');
      console.error('dateToFormatFr input', input, typeof input);
      console.error(
        'dateToFormatFr output',
        output,
        output.toString(),
        output.isValid()
      );
      console.error('-------------------');
    }
    // console.log('dateToFormatFr output', output, output.toString(), output.isValid());
    // console.log('-------------------');
    return output;
  }

  dateToMoment(input?: any) {
    const zone = 'Europe/Paris';
    moment.tz.setDefault(zone);
    moment.locale('fr');
    if (!!input) {
      return moment(input).tz(zone);
    }
    return moment().tz(zone);
  }

  async initPage() {
    if (this.networkService?.isOffline()) {
      this.navigationService.saveLinkToReload();
    }

    this.student = this.studentService.student;
    this.userLifeCycle = this.studentService.getUserLifeCycle(this.student);

    if (this.userLifeCycle.isUserGuest) {
      this.openLink('code');
      return;
    }

    const getBackNavigation = this.navigationService.checkUserNavigation();
    if (
      !!getBackNavigation &&
      !!getBackNavigation.url &&
      getBackNavigation.url !== 'reussites'
    ) {
      this.blocHeaderBackUrl = getBackNavigation.url;
    } else {
      this.blocHeaderBackUrl = 'profil';
    }

    this.drivingTheoryCertificateFileDirty = false;
    this.drivingLicenseRectoFileDirty = false;
    this.drivingLicenseVersoFileDirty = false;
    const resFetchDocumentsForIndex: any = await this.studentDocumentsService
      .fetchDocumentsForindex(this.student)
      .toPromise();
    if (
      !!resFetchDocumentsForIndex &&
      !!resFetchDocumentsForIndex.errorCode &&
      resFetchDocumentsForIndex.errorCode === 'E301'
    ) {
      this.documentsForIndex = [];
      this.fetchDocumentsForindexFailed = true;
    } else {
      this.documentsForIndex = resFetchDocumentsForIndex;
    }
    const resFetchStudentsDocumentsByUserId: any =
      await this.studentDocumentsService
        .fetchStudentsDocumentsByUserId(this.student)
        .toPromise();
    if (
      !!resFetchStudentsDocumentsByUserId &&
      !!resFetchStudentsDocumentsByUserId.errorCode &&
      resFetchStudentsDocumentsByUserId.errorCode === 'E301'
    ) {
      this.documents = [];
      this.fetchStudentsDocumentsByUserIdFailed = true;
    } else {
      this.documents = resFetchStudentsDocumentsByUserId;
    }
    this.drivingLicenseType =
      this.studentDocumentsService.documentTypeDrivingLicenseNEPH;

    this.documentsForIndex.forEach(elt => {
      if (typeof elt === 'object') {
        if (
          Object.keys(elt)[0] ===
          this.studentDocumentsService.documentTypeDrivingLicenseNEPH
        ) {
          this.drivingLicenseType =
            this.studentDocumentsService.documentTypeDrivingLicenseNEPH;
        }
        if (
          Object.keys(elt)[0] ===
          this.studentDocumentsService.documentTypeDrivingLicense
        ) {
          this.drivingLicenseType =
            this.studentDocumentsService.documentTypeDrivingLicense;
        }
      }
    });

    this.registrationCertificate = this.documents.find(
      elt =>
        elt.type ===
        this.studentDocumentsService.documentTypeRegistrationCertificate
    );

    this.drivingTheoryCertificate = this.documents.find(
      elt =>
        elt.type ===
        this.studentDocumentsService.documentTypeDrivingTheoryCertificate
    );
    this.drivingLicense = this.documents.find(
      elt => elt.type === this.drivingLicenseType
    );

    // DATE TO CHANGE
    this.maxDate = this.dateToFormatFr().toISOString().split('T')[0];

    this.pageLoaded = true;
    this.initPageDone = true;

    this.studentPurchases = this.studentService.getStudentPurshases();
    this.constructForms();

    if (
      !!this.studentPurchases.anyPurshases() &&
      !this.registrationCertificate &&
      !this.drivingTheoryCertificate &&
      !this.drivingLicense
    ) {
      this.fromNEPHInfosModal =
        getBackNavigation?.url === 'code' ||
        getBackNavigation?.url === 'conduite';
      this.openModalStartUpNEPH();
    }

    // PAGE LOAD EVENT
    if (
      !!this.navigationService.timestamp &&
      !!this.navigationService.lastLink &&
      !this.statsSent
    ) {
      const statObj = {
        page: this.navigationService.lastLink,
        loadTime: Date.now() - this.navigationService.timestamp,
        withInit: this.hasMadeInit,
      };
      if (this.statsService.isDebug) {
        console.log(statObj);
      }
      this.statsService.send({ name: 'page:view', payload: statObj });
      this.statsSent = true;
    }
    this.pageLoaderService.setSteps(
      this.pageLoaderSteps.indexOf('initPage') + 1,
      this.pageLoaderSteps.length
    );
    setTimeout(() => {
      this.pageLoaderService.stepsDone();
    }, 300);
  }

  constructForms() {
    this.constructRegistrationCertificateForm();
    this.constructDrivingTheoryCertificateForm();
    this.constructDrivingLicenseForm();

    this.formsConstructed = true;

    this.onChanges();
  }

  get getRegistrationCertificateForm() {
    return this.registrationCertificateForm.controls;
  }

  constructRegistrationCertificateForm() {
    let cleanDob = null;
    if (!!this.student && !!this.student.dob) {
      cleanDob = this.student.dob.split(/\/|-/);
    }

    this.registrationCertificateForm = this.formBuilder.group({
      firstName: new UntypedFormControl(
        '',
        Validators.compose([
          Validators.required,
          Validators.pattern(this.regexFirstName),
        ])
      ),
      lastName: new UntypedFormControl(
        '',
        Validators.compose([
          Validators.required,
          Validators.pattern(this.regexFirstName),
        ])
      ),
      gender: new UntypedFormControl(
        '',
        Validators.compose([Validators.required])
      ),
      birthdate: new UntypedFormControl(
        '',
        Validators.compose([
          Validators.required,
          Validators.pattern(this.regexDate),
        ])
      ),
      // birth_location: new FormControl(
      //   '',
      //   Validators.compose([
      //     Validators.required,
      //   ])
      // ),
      // born_abroad: new FormControl(
      //   '',
      // ),
      NEPHNumber: new UntypedFormControl(
        '',
        Validators.compose([
          Validators.required,
          Validators.pattern(this.regexNEPHNumber),
        ])
      ),
      license: new UntypedFormControl(
        '',
        Validators.compose([Validators.required])
      ),
    });
  }

  getAutocompleteValuePostalCode(value) {
    console.log(value);
    if (!!value && value.toString().trim() !== '') {
      this.registrationCertificateForm.controls['birth_location'].patchValue(
        value
      );
      this.registrationCertificateForm.controls[
        'birth_location'
      ].markAsTouched();
    } else {
      this.registrationCertificateForm.controls['birth_location'].patchValue(
        ''
      );
      this.registrationCertificateForm.controls[
        'birth_location'
      ].markAsTouched();
    }
  }

  formatBornAbroad(value) {
    return value ? 'Oui' : 'Non';
  }

  updateFormRegistrationCertificateFn() {
    if (!!this.registrationCertificate) {
      this.registrationCertificateForm.controls['firstName'].patchValue(
        this.registrationCertificate.first_name
      );
      this.registrationCertificateForm.controls['lastName'].patchValue(
        this.registrationCertificate.family_name
      );
      this.registrationCertificateForm.controls['gender'].patchValue(
        this.registrationCertificate.gender
      );
      this.registrationCertificateForm.controls['birthdate'].patchValue(
        this.registrationCertificate.dob
      );
      this.registrationCertificateForm.controls['NEPHNumber'].patchValue(
        this.registrationCertificate.number_neph
      );
      this.registrationCertificateForm.controls['license'].patchValue(
        this.registrationCertificate.categ_permis
      );
      // console.log('registrationCertificate', this.registrationCertificate);
      // console.log('first_name', this.registrationCertificate.first_name);
      // console.log('family_name', this.registrationCertificate.family_name);
      // console.log('gender', this.registrationCertificate.gender);
      // console.log('dob', this.registrationCertificate.dob);
      // console.log('number_neph', this.registrationCertificate.number_neph);
      // console.log('categ_permis', this.registrationCertificate.categ_permis);
      // console.log('values', this.registrationCertificateForm.value);
      this.updateFormRegistrationCertificate = true;
    } else {
      alert('Une erreur est survenue, merci de réessayer plus tard');
    }
  }

  resetAutocompletes() {
    this.showAutocompletes = false;
    setTimeout(() => {
      this.showAutocompletes = true;
    }, 0);
  }

  submitRegistrationCertificateForm(values) {
    // console.log('submitRegistrationCertificateForm values', values);
    if (this.networkService?.isOffline()) {
      this.launchToaster(this.offToastConf);
      return;
    }

    this.isRegistrationCertificateFormUploading = true;
    this.showModalUpload = true;

    const data = {
      type: this.studentDocumentsService.documentTypeRegistrationCertificate,
      firstName: values.firstName,
      lastName: values.lastName,
      gender: values.gender,
      birthdate: values.birthdate,
      // birth_location: values.birth_location,
      // born_abroad: values.born_abroad,
      NEPHNumber: values.NEPHNumber,
      license: values.license,
      code_exam_success_statement: true,
    };

    if (this.updateFormRegistrationCertificate) {
      this.studentDocumentsService
        .updateDocument(
          data,
          this.student.remoteId,
          this.registrationCertificate.id
        )
        .subscribe(
          async res => {
            console.log('res', res);
            if (!!res && !!res.error && !!res.status) {
              // if (res.status === 406 || res.status === 422) { // error classic
              //   const textMsg = JSON.stringify(res);
              //   this.errorMsg = JSON.parse(textMsg).error.message;
              //   this.isRegistrationCertificateFormUploading = false;
              //   this.hideModalUpload();
              //   this.showModal1 = true;
              // } else {
              //   this.errorMsg = `Nous n'avons pas pu enregistrer tes informations, merci de réessayer plus tard`;
              //   this.isRegistrationCertificateFormUploading = false;
              //   this.hideModalUpload();
              //   this.showModal1 = true;
              // }
              this.isRegistrationCertificateFormUploading = false;
              this.hideModalUpload();
              let strError = '';
              let duplicateNEPHCase = false;
              if (!!res.error.fields_in_error) {
                res.error.fields_in_error.forEach(elt => {
                  switch (elt) {
                    case 'duplicate-neph':
                      duplicateNEPHCase = true;
                      break;
                    case 'neph':
                      strError += 'numéro NEPH';
                      break;
                    case 'nom':
                      strError = strError !== '' ? strError + ' et ' : strError;
                      strError += 'ton nom';
                      break;
                    case 'prenom':
                      strError = strError !== '' ? strError + ' et ' : strError;
                      strError += 'ton prénom';
                      break;
                    case 'genre':
                      strError = strError !== '' ? strError + ' et ' : strError;
                      strError += 'ton sexe';
                      break;
                    case 'dateNaissance':
                      strError = strError !== '' ? strError + ' et ' : strError;
                      strError += 'ta date de naissance';
                      break;
                  }
                });
              }
              if (duplicateNEPHCase) {
                this.showModalErrorServerText = `duplicateNEPHCase`;
              } else if (strError !== '') {
                this.showModalErrorServerText = `Il semble y avoir une petite erreur avec ton <b>${strError}</b>.`;
              } else {
                this.showModalErrorServerText = `Il semble y avoir une petite erreur.`;
              }
              this.showModalErrorServer = true;
              this.updateFormRegistrationCertificate = false;
              this.registrationCertificateForm.reset();
              this.resetAutocompletes();
              this.initPage();
            } else {
              if (this.updateFormRegistrationCertificate) {
                this.launchToaster({
                  text: 'Tes informations ont bien été mises à jour.',
                  bgcolor: 'var(--color-info)',
                  color: 'var(--color-font)',
                });
              } else {
                this.launchToaster({
                  text: 'Ton document a bien été importé et validé.',
                  bgcolor: 'var(--color-info)',
                  color: 'var(--color-font)',
                });
              }
              this.updateFormRegistrationCertificate = false;
              this.registrationCertificateForm.reset();
              this.resetAutocompletes();
              this.isRegistrationCertificateFormUploading = false;
              this.hideModalUpload();
              this.initPage();

              this.lastObtainedBadgeInDateRange = null;
              await this.gamificationService.onInit();
              const prefectureRegistrationBadge =
                this.gamificationService.getBadgeByName(
                  'prefecture_registration'
                ) || null;
              this.lastObtainedBadgeInDateRange =
                !!prefectureRegistrationBadge &&
                this.dateToFormatFr(
                  new Date(prefectureRegistrationBadge.obtained_at)
                ).valueOf() < this.dateToFormatFr().valueOf() &&
                this.dateToFormatFr(
                  new Date(prefectureRegistrationBadge.obtained_at)
                ).valueOf() >
                  this.dateToFormatFr().valueOf() - 5000
                  ? prefectureRegistrationBadge
                  : null;

              if (!!this.lastObtainedBadgeInDateRange) {
                this.showModalLastObtainedBadge();
              }
            }
          },
          err => {
            throw new Error(
              'StudentDocumentsPage submitRegistrationCertificateForm: ' +
                JSON.stringify(err)
            );
          }
        );
    } else {
      this.studentDocumentsService
        .uploadDocument(data, this.student.remoteId)
        .subscribe(
          async res => {
            console.log('res', res);
            if (!!res && !!res.error && !!res.status) {
              // if (res.status === 406 || res.status === 422) { // error classic
              //   const textMsg = JSON.stringify(res);
              //   this.errorMsg = JSON.parse(textMsg).error.message;
              //   this.isRegistrationCertificateFormUploading = false;
              //   this.hideModalUpload();
              //   this.showModal1 = true;
              // } else if (res.status === 408) { // timeout
              //   this.errorMsg = `Nous n'avons pas pu enregistrer tes informations, merci de réessayer plus tard`;
              //   this.isRegistrationCertificateFormUploading = false;
              //   this.hideModalUpload();
              //   this.showModal1 = true;
              // } else {
              //   this.errorMsg = `Nous n'avons pas pu enregistrer tes informations, merci de réessayer plus tard`;
              //   this.isRegistrationCertificateFormUploading = false;
              //   this.hideModalUpload();
              //   this.showModal1 = true;
              // }
              if (res.status === 408) {
                // timeout
                this.errorMsg = `Nous n'avons pas pu enregistrer tes informations, merci de réessayer plus tard`;
                this.isRegistrationCertificateFormUploading = false;
                this.hideModalUpload();
                this.showModal1 = true;
              } else {
                this.isRegistrationCertificateFormUploading = false;
                this.hideModalUpload();
                let strError = '';
                let duplicateNEPHCase = false;
                if (!!res.error.fields_in_error) {
                  res.error.fields_in_error.forEach(elt => {
                    switch (elt) {
                      case 'duplicate-neph':
                        duplicateNEPHCase = true;
                        break;
                      case 'neph':
                        strError += 'numéro NEPH';
                        break;
                      case 'nom':
                        strError =
                          strError !== '' ? strError + ' et ' : strError;
                        strError += 'ton nom';
                        break;
                      case 'prenom':
                        strError =
                          strError !== '' ? strError + ' et ' : strError;
                        strError += 'ton prénom';
                        break;
                      case 'genre':
                        strError =
                          strError !== '' ? strError + ' et ' : strError;
                        strError += 'ton sexe';
                        break;
                      case 'dateNaissance':
                        strError =
                          strError !== '' ? strError + ' et ' : strError;
                        strError += 'ta date de naissance';
                        break;
                    }
                  });
                }
                if (duplicateNEPHCase) {
                  this.showModalErrorServerText = `duplicateNEPHCase`;
                } else if (strError !== '') {
                  this.showModalErrorServerText = `Il semble y avoir une petite erreur avec ton <b>${strError}</b>.`;
                } else {
                  this.showModalErrorServerText = `Il semble y avoir une petite erreur.`;
                }
                this.showModalErrorServer = true;
              }

              this.updateFormRegistrationCertificate = false;
              this.registrationCertificateForm.reset();
              this.resetAutocompletes();
              this.initPage();
            } else {
              if (this.updateFormRegistrationCertificate) {
                this.launchToaster({
                  text: 'Tes informations ont bien été mises à jour.',
                  bgcolor: 'var(--color-info)',
                  color: 'var(--color-font)',
                });
              } else {
                this.launchToaster({
                  text: 'Ton document a bien été importé et validé.',
                  bgcolor: 'var(--color-info)',
                  color: 'var(--color-font)',
                });
              }
              this.updateFormRegistrationCertificate = false;
              this.registrationCertificateForm.reset();
              this.resetAutocompletes();
              this.isRegistrationCertificateFormUploading = false;
              this.hideModalUpload();
              this.initPage();

              this.lastObtainedBadgeInDateRange = null;
              await this.gamificationService.onInit();
              const prefectureRegistrationBadge =
                this.gamificationService.getBadgeByName(
                  'prefecture_registration'
                ) || null;
              // DATE TO CHANGE
              this.lastObtainedBadgeInDateRange =
                !!prefectureRegistrationBadge &&
                this.dateToFormatFr(
                  prefectureRegistrationBadge.obtained_at
                ).valueOf() < this.dateToFormatFr().valueOf() &&
                this.dateToFormatFr(
                  prefectureRegistrationBadge.obtained_at
                ).valueOf() >
                  this.dateToFormatFr().valueOf() - 5000
                  ? prefectureRegistrationBadge
                  : null;

              if (!!this.lastObtainedBadgeInDateRange) {
                this.showModalLastObtainedBadge();
              }
            }
          },
          err => {
            throw new Error(
              'StudentDocumentsPage submitRegistrationCertificateForm: ' +
                JSON.stringify(err)
            );
          }
        );
    }
  }

  get getDrivingTheoryCertificateForm() {
    return this.drivingTheoryCertificateForm.controls;
  }

  constructDrivingTheoryCertificateForm() {
    this.drivingTheoryCertificateForm = this.formBuilder.group({
      drivingTheoryCertificateDate: new UntypedFormControl(
        '',
        Validators.compose([
          Validators.required,
          Validators.pattern(this.regexDate),
        ])
      ),
      drivingTheoryCertificateOptin: ['', Validators.required],
      drivingTheoryCertificateFile: ['', Validators.required],
    });
  }

  setCheckbox(field: string) {
    if (field === 'drivingTheoryCertificateOptin') {
      this.drivingTheoryCertificateOptin = !this.drivingTheoryCertificateOptin;
      if (this.drivingTheoryCertificateOptin) {
        this.drivingTheoryCertificateForm.controls[
          'drivingTheoryCertificateOptin'
        ].patchValue(this.drivingTheoryCertificateOptin);
      } else {
        this.drivingTheoryCertificateForm.controls[
          'drivingTheoryCertificateOptin'
        ].patchValue(null);
      }
    }
    // if (field === 'registrationCertificateOptin') {
    //   this.registrationCertificateOptin = !this.registrationCertificateOptin;
    //   if (this.registrationCertificateOptin) {
    //     this.registrationCertificateForm.controls['born_abroad'].patchValue(this.registrationCertificateOptin);
    //     this.registrationCertificateForm.controls['birth_location'].patchValue(null);
    //   } else {
    //     this.registrationCertificateForm.controls['born_abroad'].patchValue(null);
    //   }
    // }
  }

  submitDrivingTheoryCertificateForm(values) {
    if (this.networkService?.isOffline()) {
      this.launchToaster(this.offToastConf);
      return;
    }

    if (!this.studentPurchases.hasHours()) {
      this.openModalPack(
        {
          item_id: 'big_pack',
          item_promo_type: 'regular',
          item_location_id: 'marketingRegularOneHourOffres',
          item_location_format: 'modale',
          item_promo_content: 'reserved',
        },
        'marketingRegularOneHourOffres'
      );

      return;
    }

    this.isDrivingTheoryCertificateFormUploading = true;
    this.showModalUpload = true;

    const data = {
      type: this.studentDocumentsService.documentTypeDrivingTheoryCertificate,
      drivingTheoryCertificateDate: values.drivingTheoryCertificateDate,
      drivingTheoryCertificateFile: this.drivingTheoryCertificateFile,
    };
    this.studentDocumentsService
      .uploadDocument(data, this.student.remoteId)
      .subscribe(
        async res => {
          if (!!res && !!res.error && !!res.status) {
            if (res.status === 406 || res.status === 422) {
              // error classic
              const textMsg = JSON.stringify(res);
              this.errorMsg = JSON.parse(textMsg).error.message;
              this.isDrivingTheoryCertificateFormUploading = false;
              this.drivingTheoryCertificateOptin = false;
              this.hideModalUpload();
              this.showModal1 = true;
            }
            if (res.status === 408) {
              // timeout
              this.errorMsg = `Nous n'avons pas pu enregistrer tes informations, merci de réessayer plus tard`;
              this.isDrivingTheoryCertificateFormUploading = false;
              this.drivingTheoryCertificateOptin = false;
              this.hideModalUpload();
              this.showModal1 = true;
            }
            this.drivingTheoryCertificateForm.reset();
            this.resetAutocompletes();
            this.initPage();
          } else {
            // this.launchToaster({text: 'Ton document a bien été importé et est maintenant en attente de validation.', bgcolor: 'var(--color-info)', color: 'var(--color-font)'});
            this.launchToaster({
              text: 'Ton document a bien été importé et validé.',
              bgcolor: 'var(--color-success)',
              color: 'var(--color-white)',
            });
            this.drivingTheoryCertificateOptin = false;
            this.drivingTheoryCertificateForm.reset();
            this.resetAutocompletes();
            this.isDrivingTheoryCertificateFormUploading = false;
            this.hideModalUpload();
            this.cancelUpload('drivingTheoryCertificate');
            this.initPage();

            this.lastObtainedBadgeInDateRange = null;
            await this.gamificationService.onInit();
            const succeededCodeExamBadge =
              this.gamificationService.getBadgeByName('succeeded_code_exam') ||
              null;
            // DATE TO CHANGE
            this.lastObtainedBadgeInDateRange =
              !!succeededCodeExamBadge &&
              this.dateToFormatFr(
                succeededCodeExamBadge.obtained_at
              ).valueOf() < this.dateToFormatFr().valueOf() &&
              this.dateToFormatFr(
                succeededCodeExamBadge.obtained_at
              ).valueOf() >
                this.dateToFormatFr().valueOf() - 5000
                ? succeededCodeExamBadge
                : null;

            if (!!this.lastObtainedBadgeInDateRange) {
              this.showModalLastObtainedBadge();
            }
          }
        },
        err => {
          throw new Error(
            'StudentDocumentsPage submitDrivingTheoryCertificateForm: ' +
              JSON.stringify(err)
          );
        }
      );
  }

  get getDrivingLicenseForm() {
    return this.drivingLicenseForm.controls;
  }

  constructDrivingLicenseForm() {
    if (
      this.drivingLicenseType ===
      this.studentDocumentsService.documentTypeDrivingLicenseNEPH
    ) {
      this.drivingLicenseForm = this.formBuilder.group({
        licenseNumber: new UntypedFormControl(
          '',
          Validators.compose([Validators.required])
        ),
        license: new UntypedFormControl(
          '',
          Validators.compose([Validators.required])
        ),
        drivingLicenseRectoFile: new UntypedFormControl(
          '',
          Validators.compose([Validators.required])
        ),
        drivingLicenseVersoFile: new UntypedFormControl(
          '',
          Validators.compose([Validators.required])
        ),
      });
    } else {
      this.drivingLicenseForm = this.formBuilder.group({
        drivingLicenseRectoFile: new UntypedFormControl(
          '',
          Validators.compose([Validators.required])
        ),
        drivingLicenseVersoFile: new UntypedFormControl(
          '',
          Validators.compose([Validators.required])
        ),
      });
    }
  }

  getAutocompleteSelectValue(form, field, value) {
    form.controls[field].patchValue(value);
  }

  submitDrivingLicenseForm(values) {
    if (this.networkService?.isOffline()) {
      this.launchToaster(this.offToastConf);
      return;
    }

    if (!this.studentPurchases.hasHours()) {
      this.openModalPack(
        {
          item_id: 'big_pack',
          item_promo_type: 'regular',
          item_location_id: 'marketingRegularOneHourOffres',
          item_location_format: 'modale',
          item_promo_content: 'reserved',
        },
        'marketingRegularOneHourOffres'
      );

      return;
    }

    this.isDrivingLicenseFormUploading = true;
    this.showModalUpload = true;

    let data = null;

    if (
      this.drivingLicenseType ===
      this.studentDocumentsService.documentTypeDrivingLicenseNEPH
    ) {
      data = {
        type: this.studentDocumentsService.documentTypeDrivingLicenseNEPH,
        drivingLicenseRectoFile: this.drivingLicenseRectoFile,
        drivingLicenseVersoFile: this.drivingLicenseVersoFile,
        licenseNumber: values.licenseNumber,
        license: values.license,
      };
    }

    if (
      this.drivingLicenseType ===
      this.studentDocumentsService.documentTypeDrivingLicense
    ) {
      data = {
        type: this.studentDocumentsService.documentTypeDrivingLicense,
        drivingLicenseRectoFile: this.drivingLicenseRectoFile,
        drivingLicenseVersoFile: this.drivingLicenseVersoFile,
      };
    }

    this.studentDocumentsService
      .uploadDocument(data, this.student.remoteId)
      .subscribe(
        res => {
          if (!!res && !!res.error && !!res.status) {
            if (res.status === 406 || res.status === 422) {
              // error classic
              const textMsg = JSON.stringify(res);
              this.errorMsg = JSON.parse(textMsg).error.message;
              this.isDrivingLicenseFormUploading = false;
              this.hideModalUpload();
              this.showModal1 = true;
            }
            if (res.status === 408) {
              // timeout
              this.errorMsg = `Nous n'avons pas pu enregistrer tes informations, merci de réessayer plus tard`;
              this.isDrivingLicenseFormUploading = false;
              this.hideModalUpload();
              this.showModal1 = true;
            }
            this.drivingLicenseForm.reset();
            this.resetAutocompletes();
            this.initPage();
          } else {
            this.launchToaster({
              text: 'Ton document a bien été importé et est maintenant en attente de validation.',
              bgcolor: 'var(--color-info)',
              color: 'var(--color-font)',
            });
            this.drivingLicenseForm.reset();
            this.resetAutocompletes();
            this.isDrivingLicenseFormUploading = false;
            this.hideModalUpload();
            this.cancelUpload('drivingLicenseRecto');
            this.cancelUpload('drivingLicenseVerso');
            this.initPage();
          }
        },
        err => {
          throw new Error(
            'StudentDocumentsPage submitDrivingLicenseForm: ' +
              JSON.stringify(err)
          );
        }
      );
  }

  deleteDocument(event) {
    if (this.networkService?.isOffline()) {
      this.launchToaster(this.offToastConf);
      return;
    }

    let documentId = null;
    if (this.documentDeleteType === 'drivingTheoryCertificate') {
      documentId = this.drivingTheoryCertificate.id;
    }

    if (this.documentDeleteType === 'drivingLicense') {
      documentId = this.drivingLicense.id;
    }

    this.hideModalDeleteDocument();
    this.showModalDeleting = true;

    this.studentDocumentsService
      .deleteDocument(documentId, this.student.remoteId)
      .subscribe(
        res => {
          if (!!res && !!res.error && !!res.status) {
            if (res.status === 406) {
              // error classic
              const textMsg = JSON.stringify(res);
              this.errorMsg = JSON.parse(textMsg).error.msg;
              this.hideModalDeleting();
              this.showModal1 = true;
            }
            if (res.status === 408) {
              // timeout
              this.errorMsg = `Nous n'avons pas pu supprimer tes informations, merci de réessayer plus tard`;
              this.hideModalDeleting();
              this.showModal1 = true;
            }
            this.registrationCertificateForm.reset();
            this.resetAutocompletes();
          } else {
            this.launchToaster({
              text: 'Ton document a bien été supprimé.',
              bgcolor: 'var(--color-info)',
              color: 'var(--color-font)',
            });
            this.documentDeleteType = null;
            this.documentDeleteText = null;
            this.drivingTheoryCertificateFileDirty = null;
            this.drivingLicenseRectoFileDirty = null;
            this.drivingLicenseVersoFileDirty = null;
            this.hideModalDeleting();
            this.initPage();
          }
        },
        err => {
          throw new Error(
            'StudentDocumentsPage deleteDocument: ' + JSON.stringify(err)
          );
        }
      );
  }

  processFile(documentImageType, event: any) {
    this.doUpload(documentImageType);
    if (this.networkService?.isOffline()) {
      this.launchToaster(this.offToastConf);
      return;
    }
    const selectedFile = event.target.files[0];
    const reader = new FileReader();

    reader.onload = (event: any) => {
      if (this.documentImageTypeUploading === 'drivingTheoryCertificate') {
        this.drivingTheoryCertificateFile = event.target.result;
        this.drivingTheoryCertificateFileName = selectedFile.name;
      }

      if (this.documentImageTypeUploading === 'drivingLicenseRecto') {
        this.drivingLicenseRectoFile = event.target.result;
        this.drivingLicenseRectoFileName = selectedFile.name;
      }

      if (this.documentImageTypeUploading === 'drivingLicenseVerso') {
        this.drivingLicenseVersoFile = event.target.result;
        this.drivingLicenseVersoFileName = selectedFile.name;
      }

      this.documentImageTypeUploading = null;
    };

    if (!!selectedFile) {
      reader.readAsDataURL(selectedFile);
    }
  }

  doUpload(documentImageType: string) {
    if (this.networkService?.isOffline()) {
      this.launchToaster(this.offToastConf);
      return;
    }

    this.documentImageTypeUploading = documentImageType;

    setTimeout(() => {
      this.hoverModaleDisable = false;
    }, 300);

    if (this.documentImageTypeUploading === 'drivingTheoryCertificate') {
      this.drivingTheoryCertificateFileDirty = true;
    }
    if (this.documentImageTypeUploading === 'drivingLicenseRecto') {
      this.drivingLicenseRectoFileDirty = true;
    }
    if (this.documentImageTypeUploading === 'drivingLicenseVerso') {
      this.drivingLicenseVersoFileDirty = true;
    }

    // A tester en QA
    // A tester en QA
    // A tester en QA
    // A tester en QA
    // A tester en QA

    // if (this.platform.is('cordova')) {
    //   this.showModalUploadMobile = true;
    // } else {
    //   if (this.documentImageTypeUploading === 'drivingTheoryCertificate') {
    //     this.drivingTheoryCertificateFileInput.nativeElement.click();
    //   }
    //   if (this.documentImageTypeUploading === 'drivingLicenseRecto') {
    //     this.drivingLicenseRectoFileInput.nativeElement.click();
    //   }
    //   if (this.documentImageTypeUploading === 'drivingLicenseVerso') {
    //     this.drivingLicenseVersoFileInput.nativeElement.click();
    //   }
    // }
  }

  deleteFile(field, documentImageType: string) {
    field.patchValue(null);
    this.cancelUpload(documentImageType);
  }

  cancelUpload(documentImageType: string) {
    if (documentImageType === 'drivingTheoryCertificate') {
      this.drivingTheoryCertificateFile = null;
      this.drivingTheoryCertificateFileName = null;
    }
    if (documentImageType === 'drivingLicenseRecto') {
      this.drivingLicenseRectoFile = null;
      this.drivingLicenseRectoFileName = null;
    }
    if (documentImageType === 'drivingLicenseVerso') {
      this.drivingLicenseVersoFile = null;
      this.drivingLicenseVersoFileName = null;
    }
  }

  getPhoto() {
    this.cameraService.takePicture().then(img => {
      if (!!img && img !== 'No Image Selected') {
        if (this.documentImageTypeUploading === 'drivingTheoryCertificate') {
          this.drivingTheoryCertificateFile = img;
          this.drivingTheoryCertificateFileName = 'Fichier sélectionné';
        }
        if (this.documentImageTypeUploading === 'drivingLicenseRecto') {
          this.drivingLicenseRectoFile = img;
          this.drivingLicenseRectoFileName = 'Fichier sélectionné';
        }
        if (this.documentImageTypeUploading === 'drivingLicenseVerso') {
          this.drivingLicenseVersoFile = img;
          this.drivingLicenseVersoFileName = 'Fichier sélectionné';
        }
      }

      this.documentImageTypeUploading = null;
      this.hideModalUploadMobile();
    });
  }

  getFromGallery() {
    this.cameraService.getPicture().then(img => {
      if (!!img && img !== 'No Image Selected') {
        if (this.documentImageTypeUploading === 'drivingTheoryCertificate') {
          this.drivingTheoryCertificateFile = img;
          this.drivingTheoryCertificateFileName = 'Fichier sélectionné';
        }
        if (this.documentImageTypeUploading === 'drivingLicenseRecto') {
          this.drivingLicenseRectoFile = img;
          this.drivingLicenseRectoFileName = 'Fichier sélectionné';
        }
        if (this.documentImageTypeUploading === 'drivingLicenseVerso') {
          this.drivingLicenseVersoFile = img;
          this.drivingLicenseVersoFileName = 'Fichier sélectionné';
        }
      }

      this.documentImageTypeUploading = null;
      this.hideModalUploadMobile();
    });
  }

  onChanges(): void {
    this.registrationCertificateForm.valueChanges.subscribe(val => {
      this.showRegistrationCertificateFormErrors = false;
      this.isRegistrationCertificateFormUploading = false;
    });

    this.registrationCertificateForm.controls.license.valueChanges.subscribe(
      val => {
        if (val !== 'Permis B' && val !== null) {
          this.openModalCategPermisChanged();
        }
      }
    );

    this.drivingTheoryCertificateForm.valueChanges.subscribe(val => {
      this.showDrivingTheoryCertificateFormErrors = false;
      this.isDrivingTheoryCertificateFormUploading = false;
    });

    this.drivingLicenseForm.valueChanges.subscribe(val => {
      this.showDrivingLicenseFormErrors = false;
      this.isDrivingLicenseFormUploading = false;
    });
  }

  launchToaster(config) {
    this.toasterService.create(config);
  }

  hideModal1() {
    this.showModal1 = false;
  }

  hideModalUploadMobile() {
    this.showModalUploadMobile = false;
    this.hoverModaleDisable = true;
  }

  hideModalErrorServer() {
    this.showModalErrorServer = false;
    this.hoverModaleDisable = true;
  }

  hideModalUpload() {
    this.showModalUpload = false;
    this.hoverModaleDisable = true;
  }

  hideModalDeleting() {
    this.showModalDeleting = false;
  }

  callHideModalNEPH(action?) {
    this.modalNEPH.closeModal();
  }
  callhideModalJustifSavoirPlus(action?) {
    this.modalJustifSavoirPlus.closeModal();
  }

  hideModalNEPH() {
    this.displayModalNEPH = false;
  }

  openModalNEPH() {
    this.displayModalNEPH = true;
  }

  callHideModalStartUpNEPH(action?) {
    this.modalStartUpNEPH.closeModal();
  }

  hideModalStartUpNEPH() {
    this.displayModalStartUpNEPH = false;
  }

  openModalStartUpNEPH() {
    this.displayModalStartUpNEPH = true;
  }

  openLinkGouvNEPH() {
    const link =
      'https://permisdeconduire.ants.gouv.fr/demarches-en-ligne/inscription-examen-permis';
    this.openLink(link, { target: '_system', forceOutLink: true });
  }

  callHideModalCategPermis(action?) {
    this.modalCategPermis.closeModal();
  }

  hideModalCategPermis() {
    this.displayModalCategPermis = false;
  }

  openModalCategPermis() {
    this.displayModalCategPermis = true;
  }

  callHideModalLicenseNumber(action?) {
    this.modalLicenseNumber.closeModal();
  }

  hideModalLicenseNumber() {
    this.displayModalLicenseNumber = false;
  }

  openModalLicenseNumber() {
    this.displayModalLicenseNumber = true;
  }

  callHideModalCategPermisChanged(action?) {
    this.modalCategPermisChanged.closeModal();
  }

  hideModalCategPermisChanged() {
    this.displayModalCategPermisChanged = false;
  }

  openModalCategPermisChanged() {
    this.displayModalCategPermisChanged = true;
  }

  callHideModalDeleteDocument(action?) {
    this.documentDeleteType = null;
    this.documentDeleteText = null;
    this.modalDeleteDocument.closeModal();
  }

  hideModalDeleteDocument() {
    this.documentDeleteType = null;
    this.documentDeleteText = null;
    this.displayModalDeleteDocument = false;
  }

  openModalDeleteDocument(documentType: string) {
    this.displayModalDeleteDocument = true;
    this.documentDeleteType = documentType;
    if (documentType === 'drivingTheoryCertificate') {
      this.documentDeleteText = `Tu es sur le point de supprimer ton justificatif de code. Souhaites-tu continuer ?`;
    }
    if (documentType === 'drivingLicense') {
      this.documentDeleteText = `Tu es sur le point de supprimer ton permis de conduire. Souhaites-tu continuer ?`;
    }
  }

  hideModalJustifSavoirPlus() {
    this.displayModalJustifSavoirPlus = false;
  }

  showModalJustifSavoirPlus() {
    this.displayModalJustifSavoirPlus = true;
  }

  hideModalLastObtainedBadge() {
    this.displayModalLastObtainedBadge = false;
  }

  showModalLastObtainedBadge() {
    this.displayModalLastObtainedBadge = true;
  }

  async openModalPack(
    bannerInfo?: any,
    type?: string,
    noClose = false,
    customClass = ''
  ) {
    // evs-global.scss : small-modal | medium-modal
    if (!type) {
      type = 'marketingRegular';
    }
    let props;
    if (!!bannerInfo) {
      props = {
        type: type,
        bannerInfo: {
          item_id: bannerInfo.itemId,
          item_promo_type: bannerInfo.itemPromoType,
          item_location_id: bannerInfo.itemLocationId,
          item_location_format: bannerInfo.itemLocationFormat,
          item_promo_content: bannerInfo.itemPromoContent,
        },
      };
    } else {
      props = {
        type: type,
        bannerInfo: null,
      };
    }
    let modal;
    if (noClose) {
      modal = await this.modalController.create({
        component: ModalMarketingComponent,
        backdropDismiss: false,
        cssClass: customClass,
        componentProps: props,
      });
    } else {
      modal = await this.modalController.create({
        component: ModalMarketingComponent,
        cssClass: customClass,
        componentProps: props,
      });
    }
    return await modal.present();
  }

  async openModalIframe(url: any, type?: string, noClose = true) {
    if (!type) {
      type = 'iframe';
    }
    let modal;
    if (noClose) {
      modal = await this.modalController.create({
        component: ModalIframeComponent,
        backdropDismiss: false,
        cssClass: 'custom-modal-iframe',
        componentProps: {
          type: type,
          url: url,
        },
      });
    } else {
      modal = await this.modalController.create({
        component: ModalIframeComponent,
        cssClass: 'custom-modal-iframe',
        componentProps: {
          type: type,
          url: url,
        },
      });
    }
    return await modal.present();
  }

  async openLink(link, options = {}) {
    if (link === 'registrationCertificateFile') {
      this.navigationService.open(
        this.registrationCertificate.assets.data[0].links.url,
        { target: '_system', forceOutLink: true }
      );
      return;
    }

    if (link === 'drivingTheoryCertificateFile') {
      this.navigationService.open(
        this.drivingTheoryCertificate.assets.data[0].links.url,
        { target: '_system', forceOutLink: true }
      );
      return;
    }

    if (link === 'drivingLicenseRectoFile') {
      this.navigationService.open(
        this.drivingLicense.assets.data[1].links.url,
        { target: '_system', forceOutLink: true }
      );
      return;
    }

    if (link === 'drivingLicenseVersoFile') {
      this.navigationService.open(
        this.drivingLicense.assets.data[0].links.url,
        { target: '_system', forceOutLink: true }
      );
      return;
    }

    const callbackUrl = await this.navigationService.open(link, options);
    if (!!callbackUrl && callbackUrl !== '') {
      this.openModalIframe(callbackUrl);
    }
  }
}
